<script setup lang="ts">
import { explainMonsterAffix } from '@/core/monster/affix'
import type { NestMonsterType } from '@/types/monster'
import { crackRank } from '@/views/dungeon/data'
import { computed } from 'vue'
import { explainRelicIdList } from '@/core/relic'

const props = defineProps<{ monster?: NestMonsterType }>()

const randomRelicName = computed(() => {
  const relicIdList = props.monster?.relicIdList
  if (!relicIdList) return ''
  return explainRelicIdList(relicIdList)
})
</script>

<template>
  <el-popover placement="bottom" :width="300" trigger="click" popper-class="monster-detail" :teleported="false" :disabled="!monster?.name">
    <template #reference>
      <el-button size="small" type="danger" plain>
        <span v-show="monster?.name">{{ monster?.name }}</span>
        <span v-show="!monster?.name">（暂未探寻）</span>
      </el-button>
    </template>
    <div class="monster-detail" v-if="monster">
      <h3 style="margin: 5px 0">🎃{{ monster.name }}🎃</h3>
      <p>圣物线索：<span v-html="randomRelicName"></span></p>
      <p class="affix">
        藏宝图出率：<span class="info">{{ props.monster?.relicTreasureMapRate }}%</span>
      </p>
      <p>
        难度：<span :class="crackRank[monster.rank]?.class">{{ crackRank[monster.rank]?.name }}</span>
      </p>
      <p>血量：{{ monster.hp }}</p>
      <p>防御：{{ monster.def }}</p>
      <p>闪避率：{{ monster.evs }}%</p>
      <p>抗爆率：{{ monster.crtdef }}%</p>
      <template v-if="monster.special">
        <p>特性：</p>
        <p class="affix" v-for="item of explainMonsterAffix(monster.special)" v-html="item"></p>
      </template>
    </div>
  </el-popover>
</template>

<style lang="scss" scoped></style>
